<template>
  <div class="closeArrow_wrapper wrapper" :class="{show: collapsed, side_btn_right: !isLeft, side_btn_left: isLeft}">
    <div class="img_wrapper" :class="{move: collapsed}" @click="collapse">
      <img v-if="isLeft" src="/images/close_arrow_left.png" />
      <img v-if="!isLeft" src="/images/close_arrow_right.png" />
      <div class="faa-ring" v-if="collapsed && notice">
        <fa-icon icon="bell" size="2x" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CollapseButton",
  props: {
    isLeft: {
      type: Boolean,
      required: true
    },
    collapsed: {
      type: Boolean,
      required: true
    },
    notice: {
      type: Boolean,
      required: false
    }
  },
  methods: {
    collapse() {
      // ToDo 開閉状態は画面遷移時も保持するよう、VueXで管理 https://valeur.backlog.jp/view/YOSHIDA_VIRTUAL-49
      this.$emit("collapse")
    }
  }
}
</script>
